import React, { FC } from 'react';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { DEFAULT_STATUS_FILTER_SELECTED } from '../../constants/filters';
import { TABLE_COLUMN_KEYS } from '../../constants/table';
import { statusToShow } from '../../common/status/status';

interface Props {
  statusSelectedOption: string;
  handleFilter: (type: string, filterBy: string) => void;
  statusFilterOptions: string[];
}

export const StatusFilter: FC<Props> = ({ statusSelectedOption, handleFilter, statusFilterOptions }) => {
  return (
    <div className="status-filter" data-testid="status-filter">
      <DropdownMenu
        testId="status-dropdown"
        trigger={!statusSelectedOption ? DEFAULT_STATUS_FILTER_SELECTED : statusSelectedOption}
        triggerType="button"
      >
        <DropdownItemGroup>
          <DropdownItem data-testid="All statuses" onClick={() => handleFilter(TABLE_COLUMN_KEYS.STATUS, '')}>
            {DEFAULT_STATUS_FILTER_SELECTED}
          </DropdownItem>
          {statusFilterOptions.map((option) => {
            const value = statusToShow[option];
            return (
              <DropdownItem
                data-testid={`Status ${value}`}
                onClick={() => handleFilter(TABLE_COLUMN_KEYS.STATUS, value)}
                key={value}
              >
                {value}
              </DropdownItem>
            );
          })}
        </DropdownItemGroup>
      </DropdownMenu>
    </div>
  );
};
